.root {
  display: flex;
  flex-direction: row;
  flex-wrap: var(--group-wrap, wrap);
  justify-content: var(--group-justify, flex-start);
  align-items: var(--group-align, center);
  gap: var(--group-gap, var(--mantine-spacing-md));

  &:where([data-grow]) {
    & > * {
      flex-grow: 1;
      max-width: var(--group-child-width);
    }
  }
}
